import { AxiosRequestConfig } from 'axios';

import { State } from 'model/State';
import hamsClient from 'modules/hams';
import { selectHamsClientConfig } from 'modules/auth/selectors';

import { baseGenericPropertyApiUrl } from '../..';
import { getImpersonationHeader } from 'util/mac/helpers';

export const getFromHamsClient = async (
  remainingPath: string,
  state: State,
  params?: AxiosRequestConfig['params'],
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    return (
      await hamsClient.get(`${baseGenericPropertyApiUrl}${remainingPath}`, {
        ...config,
        headers: {
          ...config.headers,
          ...impersonationHeader,
        },
        params,
      })
    ).data;
  } catch (error) {
    return Promise.reject(error);
  }
};
